module.exports = require('./isAbsoluteUrl')
